module.exports = __webpack_public_path__ + "static/media/verdeElephant_wide.7bbb1256.jpg";